import { GGOBaseComponent } from '../components/ggo.base.component.js';
export class Toast {
    static error(text) {
        const toast = this.createToast(text, 'error');
    }
    static success(text) {
        const toast = this.createToast(text, 'success');
    }
    static warning(text) {
        const toast = this.createToast(text, 'warning');
    }
    static createToast(text, variant) {
        const toast = GGOBaseComponent.createElement('ggo-toast');
        toast.text = text;
        if (variant) {
            toast.variant = variant;
        }
        document.body.appendChild(toast);
        return toast;
    }
}
